import { ComponentChild } from 'preact'
import { useMemo } from 'preact/hooks'
import { Grid, Header } from 'semantic-ui-react'

import { chunkArray } from '../../../utils'
import { Option, SymbologyOption, SymbologyOptionExtension } from '../../../store/SymbologyOption'
import { Switch } from '../../atoms'

const SymbologiesOptionGrid = ({
  title,
  symbologiesOptions,
  symbologiesOptionsAddon,
  toggleSymbology,
  toggleAddon,
}: {
  title: ComponentChild
  symbologiesOptions: SymbologyOption[]
  symbologiesOptionsAddon?: SymbologyOptionExtension[]
  toggleSymbology: (symbologyOption: SymbologyOption) => void
  toggleAddon?: (symbologyOptionAddon: SymbologyOptionExtension) => void
}) => {
  const options = useMemo(
    () => chunkArray<Option>([...symbologiesOptions, ...(symbologiesOptionsAddon ?? [])], 3),
    [symbologiesOptions, symbologiesOptionsAddon]
  )
  return (
    <>
      <Header textAlign="center" as="h4">
        {title}
      </Header>
      <Grid columns={3} stretched>
        {options.map((row, index) => {
          return (
            <Grid.Row verticalAlign="top" key={index}>
              {row.map((option: Option) => {
                if (option instanceof SymbologyOption) {
                  return (
                    <Grid.Column textAlign="center" key={option.symbology}>
                      <Switch
                        label={option.description.readableName}
                        checked={option.checked.value}
                        onChange={() => toggleSymbology(option)}
                      />
                    </Grid.Column>
                  )
                } else if (option instanceof SymbologyOptionExtension) {
                  return (
                    <Grid.Column textAlign="center" key={option.extension.name}>
                      <Switch
                        label={option.extension.humanReadable}
                        checked={option.checked.value}
                        onChange={() => toggleAddon?.(option)}
                      />
                    </Grid.Column>
                  )
                }
              })}
            </Grid.Row>
          )
        })}
      </Grid>
    </>
  )
}

export default SymbologiesOptionGrid
